import { APIError } from 'src/api';

/** A blob response hides the backend's JSON error body — reads its message back out. */
export async function blobErrorMessage(error?: APIError): Promise<string> {
    const body = error?.axios?.response?.data;
    if (body instanceof Blob) {
        try {
            const parsed = JSON.parse(await body.text());
            if (typeof parsed?.message === 'string') return parsed.message;
            if (typeof parsed?.detail === 'string') return parsed.detail;
        } catch {
            // not JSON — the transport message below
        }
    }
    return error?.message ?? 'Unknown Error';
}
